import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { API_ENDPOINTS } from '../constants/api-endpoints';

export interface FileUploadResponse {
  blobName?: string;
  BlobName?: string;
  fileName?: string;
  FileName?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.host;

  get<T>(url: string, params?: HttpParams): Observable<T> {
    return this.http.get<T>(`${this.baseUrl}${API_ENDPOINTS.BASE_PATH}${url}`, { params });
  }

  post<T>(url: string, body: any): Observable<T> {
    return this.http.post<T>(`${this.baseUrl}${API_ENDPOINTS.BASE_PATH}${url}`, body);
  }

  put<T>(url: string, body: any, params?: HttpParams): Observable<T> {
    return this.http.put<T>(`${this.baseUrl}${API_ENDPOINTS.BASE_PATH}${url}`, body, { params });
  }

  patch<T>(url: string, body: any, params?: HttpParams): Observable<T> {
    return this.http.patch<T>(`${this.baseUrl}${API_ENDPOINTS.BASE_PATH}${url}`, body, { params });
  }

  delete<T>(url: string): Observable<T> {
    return this.http.delete<T>(`${this.baseUrl}${API_ENDPOINTS.BASE_PATH}${url}`);
  }

  uploadFile(file: File): Observable<FileUploadResponse> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<FileUploadResponse>(`${this.baseUrl}/api/file/upload`, formData);
  }
}

